import urls from '../constants/urls.js';
import { fetch } from 'domain-task';
import BaseService from './baseService';

class InstrumentService {   
    static getInstruments() {
        return BaseService.getAndReturn(`/Instruments`, BaseService.returnAssignedArray, 'Unable to fetch instruments', true);
    }
}
export default InstrumentService;